import { Pipe, PipeTransform } from '@angular/core';
import { StatusPill } from '../models/shared/status-pill';
import { buildSplitStatusPill } from '../utils/split-status-pill-utils';

@Pipe({
  name: 'splitStatusPill',
  standalone: true
})
export class SplitStatusPillPipe implements PipeTransform {
  transform(hasSplitLegs: boolean): StatusPill | null {
    return buildSplitStatusPill(hasSplitLegs);
  }
}
